import { Group } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

/**
 * Returns a {@link Group} matching the given name.
 * @param name - The name of the group to find.
 * @returns - The matching {@link Group} or `null` if no match was found. Errors other than an
 *   expired session surface as the query error.
 */

export function useGroupByName(name?: string) {
  const { geotabClient, activeSessionId, clearGeotabClient } = useGeotabClient();
  return useQuery({
    queryKey: ["group", activeSessionId, name],
    queryFn: ({ signal }) => {
      // Fetch data from geotabClient once it's ready
      return geotabClient
        .get("Group", { name }, 1, signal)
        .then((groups: Group[]) => groups?.[0] ?? null)
        .catch(e => {
          if (e instanceof Error && e.message.includes("Invalid session") && activeSessionId) {
            clearGeotabClient(activeSessionId);
            console.log("Session expired, clearing Geotab client");
            return null;
          }
          throw e;
        });
    },

    enabled: !!name,
  });
}
